import React from "react";
import styled, { css } from "styled-components";
import { Spinner, Timestamp } from "components/common";
import { Alert } from "components/bootstrap";
import useAIQuotaStatus from "ai/hooks/useAIQuotaStatus";
const StyledSpan = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.text.secondary};
  `
);
const AIQuotaInfo = ({ text = "reports remaining today" }) => {
  const { data, isLoading, isError } = useAIQuotaStatus();
  if (isLoading) return /* @__PURE__ */ React.createElement(Spinner, null);
  if (!data || isError) return null;
  if (!data.limit || !data.used) return null;
  const quotaUsageInPercent = Math.round(data.used / data.limit * 100);
  const isLimitExceeded = (data == null ? void 0 : data.remaining) === 0;
  if (isLimitExceeded) {
    return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", title: `${quotaUsageInPercent}% of AI quota used` }, "You have used ", /* @__PURE__ */ React.createElement("strong", null, quotaUsageInPercent, "%"), " of your quota (", data.remaining, "/", data.limit, " remaining).", data.reset_at && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("br", null), "Your quota will be reset on", " ", /* @__PURE__ */ React.createElement("strong", null, /* @__PURE__ */ React.createElement(Timestamp, { dateTime: data.reset_at, format: "shortReadable" })), "."));
  }
  return /* @__PURE__ */ React.createElement(StyledSpan, null, /* @__PURE__ */ React.createElement("b", null, data.remaining, "/", data.limit), " ", text);
};
export default AIQuotaInfo;
